import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * Password Reset API service
 */
export const PasswordResetApi = {
  /**
   * Request password reset
   * @param {string} email - User email
   * @returns {Promise<Response>} Password reset request response
   */
  requestPasswordReset: async (email) => {
    const queryParams = new URLSearchParams({ email }).toString();
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/request-reset?${queryParams}`, {
      method: 'POST',
    });
  },

  /**
   * Reset password with token
   * @param {string} token - Reset token
   * @param {string} newPassword - New password
   * @returns {Promise<Response>} Password reset response
   */
  resetPassword: async (token, newPassword) => {
    const queryParams = new URLSearchParams({ token, newPassword }).toString();
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/reset-password?${queryParams}`, {
      method: 'POST',
    });
  },

  /**
   * Reset password by email (Admin only)
   * @param {string} email - User email
   * @param {string} newPassword - New password
   * @returns {Promise<Response>} Password reset response
   */
  resetPasswordByEmail: async (email, newPassword) => {
    const queryParams = new URLSearchParams({ email, newPassword }).toString();
    return fetchWithAuth(`${DATA_SERVICE_BASE_URL}/api/users/reset-password-email?${queryParams}`, {
      method: 'POST',
    });
  }
};